module.exports = __webpack_public_path__ + "img/earth-bump.69693f85.jpg";